import React from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_EMAIL, OFFICE_LOCATION, whatsappLink, telLink } from "@/lib/api";
import EnquiryForm from "@/components/EnquiryForm";
import SectionHeader from "@/components/SectionHeader";
import SEO, { LOCAL_BUSINESS_JSONLD } from "@/components/SEO";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Apurba Estate"
        description="Call, WhatsApp or email Apurba Estate for property consulting, land surveying and documentation support in Kolkata and South 24 Parganas."
        path="/contact"
        jsonLd={LOCAL_BUSINESS_JSONLD}
      />
      <section className="bg-[#101827] text-white">
        <div className="ae-container pt-28 pb-14">
          <div className="ae-eyebrow mb-3">Contact</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold">Let's talk about your property.</h1>
          <p className="text-white/75 mt-4 max-w-2xl">Call, WhatsApp or write to us. We respond within one business day.</p>
        </div>
      </section>

      <section className="ae-section">
        <div className="ae-container grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-5">
            <InfoCard icon={MapPin} title="Service Region" value={OFFICE_LOCATION} />
            <InfoCard icon={Phone} title="Phone" value={BUSINESS_PHONE} href={telLink()} />
            <InfoCard icon={Mail} title="Email" value={BUSINESS_EMAIL} href={`mailto:${BUSINESS_EMAIL}`} />
            <InfoCard icon={Clock} title="Business Hours" value="Mon – Sat · 10:00 AM – 7:00 PM" />
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="ae-btn-whatsapp w-full justify-center">
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="ae-card p-6 md:p-8">
              <EnquiryForm defaultService="general_contact" sourcePage="contact" title="Send us a message" />
            </div>
          </div>
        </div>
      </section>

      <section className="ae-section bg-[#F4F6F8] pt-0">
        <div className="ae-container">
          <div className="ae-card overflow-hidden">
            <iframe
              title="Service area map"
              src="https://www.google.com/maps?q=Kolkata%2C+West+Bengal&output=embed"
              className="w-full h-[380px] border-0"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
}

function InfoCard({ icon: Icon, title, value, href }) {
  const inner = (
    <div className="ae-card p-5 flex items-start gap-4">
      <div className="w-11 h-11 rounded-lg bg-[#101827] text-[#C5A46D] flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
      <div>
        <div className="text-xs uppercase tracking-wider text-[#64748B]">{title}</div>
        <div className="font-semibold text-[#101827] text-sm mt-0.5">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href}>{inner}</a> : inner;
}
